import React from 'react';
import classNames from 'classnames';
import styles from './index.less';
import PrettyDate from '@/components/PrettyDate';
import { FileOutlined } from '@ant-design/icons';
import { Space, Tag } from 'antd';
import { MergedFileModel } from '@/typings/models/Lead';
import { F } from '@/utils/intl';

export interface FileItemProps {
  file: MergedFileModel;
  openFilesDrawer: () => void;
}

export default function FileItem({ file, openFilesDrawer }: FileItemProps) {
  const fileName = file.path.split('/').pop() || 'Unknown file';
  const date = file.uploaded_at;

  return (
    <div
      onClick={openFilesDrawer}
      className={classNames(
        styles.projectDetailItemContainer,
        styles.fileItemContainer,
        styles.projectDetailItemContainerClickable,
      )}
    >
      <div className={styles.projectDetailItemContent}>
        <div className={styles.projectDetailItemHeader}>
          <Space size={8}>
            <FileOutlined />
            {fileName}
            {file.source === 'customer' && (
              <Tag color="blue" bordered={false}>
                <F id="entity.customer.singular" defaultMessage="Customer" />
              </Tag>
            )}
          </Space>
        </div>
        <div className={styles.projectDetailItemBody}>
          <PrettyDate date={date} />
        </div>
      </div>
    </div>
  );
}
